define('plugins/musicfavourite/ui/menu-view',['./dom', 'plugins/musicfavourite/ui/localisation'], function(DOM, Localisation) {
    'use strict';

    var feedbackOverlay;

    var classes = {
        'button': 'p-f-button',
        'hide': 'p-f-hide',
        'feedbackOverlay': 'p-f-feedback-added-overlay',
        'feedbackOverlayContent': 'p-f-feedback-content',
        'feedbackButton': 'p-f-feedback-button',
        'preFeedbackLabel': 'p-f-pre-feedback',
        'feedbackLabel': 'p-f-feedback-label',
        'optionsButton': 'p-f-options-button',
        'undoButton': 'p-f-undo-feedback',
        'itemTitle': 'p-f-feedback-item-title',
        'spinner': 'p-f-feedback-spinner',
        'overlayLabel': 'p-f-feedback-label',
        'geliconSpinner': 'p-f-gelicon-spinner gelicon gelicon--load'
    };

    var init = function(element, cardSelector, itemTitle, translations, lang) {
        var feedbackOptionText = Localisation.getLocalisedString(translations, 'feedbackOption', 'options', lang);
        var preFeedbackText = Localisation.getLocalisedString(translations, 'preFeedbackText', 'options', lang);
        preFeedbackText = (preFeedbackText == "preFeedbackText") ? "" : preFeedbackText;
        var feedbackConfirmationText = Localisation.getLocalisedString(translations, 'feedbackConfirmation', 'options', lang);
        var undoText = Localisation.getLocalisedString(translations, 'undo', 'options', lang);

        styleOptionsPanel(element);
        renderLabelText(element, feedbackOptionText);
        feedbackOverlay = renderFeedbackOverlay(element, cardSelector, itemTitle, preFeedbackText, feedbackConfirmationText, undoText);
    };

    var styleOptionsPanel = function(element) {
        // The js only version of the button is contained in a span with class "p-form", rather than a form element
        var form = DOM.findElement("form", element)[0] || DOM.findElement(".p-form", element)[0];
        var optionsButton = DOM.findElement('.' + classes['optionsButton'], element)[0];
        var footerHeight = element && element.clientHeight ? element.clientHeight : "0";
        DOM.css(form, {
            marginRight: footerHeight + "px"
        });
        DOM.css(optionsButton, {
            display: 'flex',
            height: footerHeight + "px",
            width: footerHeight + "px"
        });
    };

    var renderLabelText = function(element, text) {
        var feedbackLabel = DOM.findElement('.' + classes['feedbackLabel'], element)[0];
        DOM.append(feedbackLabel, text);
    };

    var renderFeedbackOverlay = function(element, cardSelector, itemTitle, preFeedbackText, feedbackConfirmationText, undoText) {
        if (cardSelector) {
            var card = DOM.findClosestParent(element, cardSelector);
            if (!card) {
                console.warn("Cannot find card from selector: " + cardSelector);
                return null;
            }
            var overlay = [
                '<div class="', classes['feedbackOverlay'], ' ', classes['hide'], '">',
                '<div class="', classes['spinner'], '">',
                '<i class="', classes['geliconSpinner'], '"></i></div>',
                '<div class="', classes['feedbackOverlayContent'], '">',
                '<div class="', classes['overlayLabel'], ' ', classes['preFeedbackLabel'], '">', preFeedbackText, '</div>',
                '<div class="', classes['itemTitle'],'">"', itemTitle, '"</div>',
                '<div class="', classes['overlayLabel'],'">', feedbackConfirmationText, '</div>',
                '<div class="', classes['undoButton'], '">', undoText, '</div></div></div>'
            ].join("");

            DOM.append(card, overlay);
            var overlayElement = card.querySelector("." + classes['feedbackOverlay']);
            DOM.css(overlayElement, {
                fontSize: element.style.fontSize
            });

            if (preFeedbackText == '') {
                DOM.hide(DOM.findElement('.' + classes['preFeedbackLabel'], overlayElement));
            }
            return overlayElement;
        }
        return null;
    };

    return {
        'initialise': init,
        'styleOptionsPanel': styleOptionsPanel,
        'getFeedbackOverlay': function() {
            return feedbackOverlay;
        }
    };
});
